<template lang="pug">
  #forced-change-password
    HeaderForLogin
    b-container.mx-auto.body-width.pb-2
      template(v-if="isLoading === true")
        loading(:height="200")
      template(v-else)
        h2.text-center.pt-5.font-weight-bold.white-space パスワードを設定してください
        b-card(header-tag="header")
          .form-box.mx-auto
           b-form(@submit.prevent="$bvModal.show('order_confirm')")
             b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="resetPassword", ok-title="はい", cancel-title="いいえ")
               span このパスワードに変更します。<br>本当によろしいですか？
             change-password-form.mt-3(:password="password", :re_password="re_password")
             b-button.float-right.mr-3.mt-3(type="submit", :disabled="isSubmitButtonDisabled", variant="outline-success") 変更する
</template>

<script>
import Loading from '@/components/Loading';
import ChangePasswordForm from "@/components/supportSite/ChangePasswordForm";
import Api from "@/repositories/api";
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

const S208PasswordReset = Api.get("s208PasswordReset");

export default {
  name: "ResettingPassword",
  components: {
    Loading,
    ChangePasswordForm,
    HeaderForLogin,
  },
  data() {
    return {
      // パスワード
      password: {
        value: "",
        placeholder: "6文字以上・半角英数字記号",
        error_msg_list: []
      },

      // パスワード(確認用)
      re_password: {
        value: "",
        placeholder: "確認のためにもう一度入力してください",
        error_msg_list: []
      },

      // トークン
      token: "",

      // 読み込み中フラグ
      isLoading: false,

      // 「変更する」ボタン無効フラグ
      isSubmitButtonDisabled: false
    }
  },
  // 画面表示前処理
  created() {
    // 読み込み開始
    this.isLoading = true;

    // クエリパラメータからトークン取得
    this.token = this.$route.query.token;

    // パスワードリセットチェック処理
    S208PasswordReset.check(this.token)
    // 失敗
    .catch((error) => {
      // 共通のエラー処理
      this.apiError(error, "画面表示処理")

      // パスワード設定関連のエラーの場合
      if (error.response.status === 400) {
        // パスワード設定関連のエラー画面へ遷移する
        this.$router.push({
          name: 'RelatedPasswordSetting',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: error.response.data.error_list[0].error_msg
          }
        })
      }
    })
    .finally(() => {
      // 読み込み終了
      this.isLoading = false;
    })
  },
  methods: {
    resetPassword() {
      // エラーメッセージを初期化する
      this.password.error_msg_list    = []; // パスワード
      this.re_password.error_msg_list = []; // パスワード(確認用)

      // リクエストデータ作成
      let requestData = {
        token:       this.token,            // パスワードリセットトークン
        password:    this.password.value,   // パスワード
        re_password: this.re_password.value // パスワード(確認用)
      }

      // 「変更する」ボタンをロックする
      this.isSubmitButtonDisabled = true;

      // パスワードリセット実行処理呼び出し
      S208PasswordReset.edit(requestData)
      // 処理成功
      .then(() => {
        // パスワードリセット完了画面へ遷移する
        this.$router.push({
          name: 'DoneResetPassword',
        })
      })
      // 失敗
      .catch((error) => {
        // 「変更する」ボタンのロックを外す
        this.isSubmitButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(error, "変更処理")

        // バリデーションエラー
        if (error.response.data && error.response.data.error_list) {
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージの項目がある場合
            if (errorData.target !== undefined && this[errorData.target] !== undefined) {
              this[errorData.target].error_msg_list.push(errorData.error_msg)
            }
            // エラーメッセージの項目がない場合
            else {
              // パスワード設定関連のエラー画面へ遷移する
              this.$router.push({
                name: 'RelatedPasswordSetting',
                params: {
                  // 画面に表示するエラーメッセージ
                  error_msg: error.response.data.error_list[0].error_msg
                }
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.form-box {
  max-width: 800px;
}
</style>